export function mapShipmentStatusBtn(
  is_shipped: Boolean,
  is_delivered: Boolean,
  is_cancel: Boolean,
  is_cancel_completed: Boolean,
  size?: string
) {
  let is_dark_text = false;
  let status = 'Created';
  let className = 'created-chip';

  if (is_cancel_completed) {
    status = 'Cancelled';
    className = 'bg-danger';
    is_dark_text = false;
  } else if (is_cancel) {
    status = 'Cancelling';
    className = 'bg-secondary';
    is_dark_text = false;
  } else if (is_delivered) {
    status = 'Delivered';
    className = 'bg-success';
    is_dark_text = false;
  } else if (is_shipped) {
    status = 'In Progress';
    className = 'inprogress-chip';
    is_dark_text = false;
  }

  if (is_dark_text) {
    className += ' text-dark';
  }
  return (
    <span className={`badge rounded-pill ${size} ${className}`}>{status}</span>
  );
}
export function mapShipmentStatus(
  is_shipped: Boolean,
  is_delivered: Boolean,
  is_cancel: Boolean,
  is_cancel_completed: Boolean,
  size?: string
) {
  let is_dark_text = false;
  let status = 'Created';
  let className = 'created-chip';

  if (is_cancel_completed) {
    status = 'Cancelled';
    className = 'bg-danger';
    is_dark_text = false;
  } else if (is_cancel) {
    status = 'Cancelling';
    className = 'bg-secondary';
    is_dark_text = false;
  } else if (is_delivered) {
    status = 'Delivered';
    className = 'bg-success';
    is_dark_text = false;
  } else if (is_shipped) {
    status = 'In Progress';
    className = 'inprogress-chip';
    is_dark_text = false;
  }

  if (is_dark_text) {
    className += ' text-dark';
  }
  return status;
}
export function getLegStatus(latest_status: { [x: string]: any }) {
  let is_dark_text = true;
  let class_names = '';
  let status =
    latest_status['status'] !== undefined ? latest_status['status'] : 'Created';

  switch (status) {
    case 'Delivered':
      class_names = 'delivered-chip';
      is_dark_text = false;
      break;
    case 'Undeliverable':
      class_names = 'delivered-chip';
      is_dark_text = false;
      break;
    case 'DeliveryException':
      class_names = 'delivered-chip';
      is_dark_text = false;
      break;
    case 'OutForDelivery':
      class_names = 'delivered-chip';
      is_dark_text = false;
      break;
    case 'InTransit':
      class_names = 'intransit-chip';
      is_dark_text = false;
      break;
    case 'Pickup':
      class_names = 'pickup-chip';
      is_dark_text = false;
      break;
    case 'Created':
      class_names = 'created-chip';
      is_dark_text = false;
      break;
    case 'Quoted':
      class_names = 'created-chip';
      is_dark_text = false;
      break;
    default:
      class_names = 'inprogress-chip';
      is_dark_text = false;
  }

  if (is_dark_text) {
    class_names += ' text-dark';
  }
  return <span className={`badge rounded-pill ${class_names}`}>{status}</span>;
}
export function getTrackingStatus(status: string) {
  let is_dark_text = true;
  let class_names = '';

  switch (status) {
    case 'Delivered':
      class_names = 'delivered-chip';
      is_dark_text = false;
      break;
    case 'Undeliverable':
      class_names = 'delivered-chip';
      is_dark_text = false;
      break;
    case 'DeliveryException':
      class_names = 'delivered-chip';
      is_dark_text = false;
      break;
    case 'OutForDelivery':
      class_names = 'delivered-chip';
      is_dark_text = false;
      break;
    case 'InTransit':
      class_names = 'intransit-chip';
      is_dark_text = false;
      break;
    case 'Pickup':
      class_names = 'pickup-chip';
      is_dark_text = false;
      break;
    case 'Created':
      class_names = 'created-chip';
      is_dark_text = false;
      break;
    default:
      class_names = 'inprogress-chip';
      is_dark_text = false;
  }

  if (is_dark_text) {
    class_names += ' text-dark';
  }
  return <span className={`badge rounded-pill ${class_names}`}>{status}</span>;
}
export function getJobsStatus(status: string) {
  let is_dark_text = true;
  let class_names = '';

  switch (status) {
    case 'COMPLETED':
      class_names = 'delivered-chip';
      is_dark_text = false;
      break;
    case 'CANCELLED':
      class_names = 'intransit-chip';
      is_dark_text = false;
      break;
    case 'CREATED':
      class_names = 'created-chip';
      is_dark_text = false;
      break;
    default:
      class_names = 'inprogress-chip';
      is_dark_text = false;
  }

  if (is_dark_text) {
    class_names += ' text-dark';
  }
  return (
    <span className={`badge rounded-pill ${class_names}`}>
      {status === 'CREATED'
        ? 'Created'
        : status
        ? status.replace(/_/g, ' ')
        : ''}
    </span>
  );
}
export const renderPagination = (
  totalItems: number,
  currentPage: number,
  pageSize: number,
  setCurrentPage: (page: number) => void
) => {
  const totalPages = Math.ceil(totalItems / pageSize);
  const handlePageClick = (page: number) => {
    setCurrentPage(page);
  };

  const pages = [];
  const visiblePages = 1;

  const startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  const endPage = Math.min(totalPages, startPage + visiblePages - 1);
  if (currentPage > 1) {
    pages.push(
      <li className='page-item'>
        <button
          className='page-link bg-transparent border border-0 text-dark'
          aria-label='Previous'
          onClick={() => handlePageClick(currentPage - 1)}
        >
          <span aria-hidden='true'>&laquo;</span>
        </button>
      </li>
    );
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <li
        key={i}
        className={`page-link bg-transparent border border-0 text-dark page-item ${
          currentPage === i ? 'active' : ''
        }`}
        onClick={() => handlePageClick(i)}
      >
        <button className='page-link'>{i}</button>
      </li>
    );
  }
  if (currentPage < totalPages) {
    pages.push(
      <li className='page-item'>
        <button
          className='page-link bg-transparent border border-0 text-dark'
          aria-label='Next'
          onClick={() => handlePageClick(currentPage + 1)}
        >
          <span aria-hidden='true'>&raquo;</span>
        </button>
      </li>
    );
  }

  return pages;
};
export const handleDownloadFile = (
  base64Content: string,
  fileName: string,
  throwError?: boolean
) => {
  try {
    const decodedData = atob(base64Content);
    const arrayBuffer = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; ++i) {
      arrayBuffer[i] = decodedData.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    if (throwError) {
      throw error;
    }
    console.error('Error downloading file:', error);
  }
};
export function mapTrackStatusBtn(status: string, size?: string) {
  let is_dark_text = true;
  let className = 'bg-light';

  if (status === 'Cancelled') {
    className = 'cancelled-chip';
    is_dark_text = false;
  } else if (status === 'Canceled') {
    className = 'cancelled-chip';
    is_dark_text = false;
  } else if (status === 'Cancelling') {
    className = 'bg-secondary';
    is_dark_text = false;
  } else if (status === 'Delivered') {
    className = 'delivered-chip';
    is_dark_text = false;
  } else if (status === 'In Progress') {
    className = 'inprogress-chip';
    is_dark_text = false;
  } else if (status === 'Created') {
    className = 'created-chip';
    is_dark_text = false;
  } else if (status === 'Pickup') {
    className = 'pickup-chip';
    is_dark_text = false;
  } else if (status === 'InTransit') {
    className = 'intransit-chip ';
    is_dark_text = false;
  } else if (status === 'OutForDelivery') {
    className = 'delivered-chip';
    is_dark_text = false;
  } else if (status === 'DeliveryException') {
    className = 'delivered-chip';
    is_dark_text = false;
  }

  if (is_dark_text) {
    className += ' text-dark';
  }
  return (
    <span className={`badge rounded-pill ${size} ${className}`}>{status}</span>
  );
}

export const filterRatesByModeCode = (ratesResponse: any, modeCode: string) => {
  const filteredRates = ratesResponse.content.rates.filter(
    (rate: any) => rate.mode_code !== modeCode
  );
  ratesResponse.content.rates = filteredRates;
  return ratesResponse;
};

export function lmsStatusChips(status: string) {
  let is_dark_text = true;
  let className = 'bg-light';

  if (status === 'Rush' || status === 'Picked' || status === 'Breakdown') {
    className = 'lms_on_hand';
    is_dark_text = false;
  } else if (status === 'On_Hand') {
    className = 'lms_on_hand';
    status = 'On-Hand';
    is_dark_text = false;
  } else if (
    status === 'Delivered' ||
    status === 'Standard' ||
    status === 'Normal'
  ) {
    className = 'lms_delivered';
    is_dark_text = false;
  } else if (
    status === 'Loaded' ||
    status === 'Deck' ||
    status === 'Arrived' ||
    status === 'Hercules_Freight'
  ) {
    className = 'lms_loaded';
    is_dark_text = false;
  } else if (status === 'In_Transit') {
    className = 'lms_in_transit';
    status = 'In-Transit';
    is_dark_text = false;
  } else if (status === 'Winter Road' || status === 'Received') {
    className = 'lms_in_transit';
    is_dark_text = false;
  } else if (status === 'Planned') {
    className = 'lms_planned';
    is_dark_text = false;
  } else if (
    status === 'Code 99' ||
    status === 'High' ||
    status === 'Deleted'
  ) {
    className = 'code_99';
    is_dark_text = false;
  } else if (
    status === 'Unpicked' ||
    status === 'Unreceived' ||
    status === 'Unloaded' ||
    status === 'Location_Changed' ||
    status === 'Status_Changed' ||
    status === 'Deconsolidated'
  ) {
    className = 'unpicked';
    is_dark_text = false;
  } else if (status === 'Arrived') {
    className = 'arrived';
    is_dark_text = false;
  } else if (status === 'Boarded' || status === 'Unboarded') {
    className = 'boarded';
    is_dark_text = false;
  } else if (status === 'Checked_In' || status === 'Unboarded') {
    className = 'checkedIn';
    is_dark_text = false;
  } else if (status === 'Transferred') {
    className = 'transferred';
    is_dark_text = false;
  } else if (status === 'Final_Destination') {
    className = 'transferred';
    status = 'Final-Destination';
    is_dark_text = false;
  }
  if (is_dark_text) {
    className += ' text-dark';
  }
  return <span className={`lms_chip  ${className}`}>{status}</span>;
}
